// @ts-nocheck
import dice1 from '@/components/games/dice/images/dice/1.png';
import dice2 from '@/components/games/dice/images/dice/2.png';
import dice3 from '@/components/games/dice/images/dice/3.png';
import dice4 from '@/components/games/dice/images/dice/4.png';
import dice5 from '@/components/games/dice/images/dice/5.png';
import dice6 from '@/components/games/dice/images/dice/6.png';
import { fixAssetUrl } from '@/utilities/Utilities';

export default [
  fixAssetUrl(dice1),
  fixAssetUrl(dice2),
  fixAssetUrl(dice3),
  fixAssetUrl(dice4),
  fixAssetUrl(dice5),
  fixAssetUrl(dice6)
];
